





















































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import Pagination from "@/components/paginaiton.vue";
import AddHospitalDialog from "./add-hospital-dialog.vue";
@Component({
  components: {
    Pagination,
    AddHospitalDialog
  }
})
export default class HospitalManage extends Vue {
  private project: any = {
    project_id: ""
  };
  private filters: any = {};
  private hospitals: any[] = [];
  // 翻页
  private currentPage: any = 1;
  private totalPage: any = 0;
  private totalCount: any = 0;
  private pageSize: any = 10;
  private orderValue: any = 1;
  // 弹窗
  private ifShowAddHospitalDialog: boolean = false;
  /**
   * @description 获得项目信息
   */
  private fetchProject() {
    return new Promise((resolve, reject) => {
      const params: any = {
        params: {
          project_id: this.project.project_id
        }
      };
      axios
        .get("api/project", params)
        .then(({ data }) => {
          resHandle(this, data).then(() => {
            this.project = data.data;
            resolve();
          });
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 打开添加分中心弹窗
   */
  private addHospital() {
    this.ifShowAddHospitalDialog = true;
  }
  /**
   * @description 获取版本列表
   */
  private fetchHospitals() {
    const params: any = {
      params: {
        project_id: this.project.project_id,
        search: this.filters.search,
        current_page: this.currentPage,
        page_count: this.pageSize,
        order_value: this.orderValue
      }
    };
    axios.get("api/project/prohospitals", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.hospitals = data.data.hospitals;
        this.totalCount = data.data.total_count;
        this.totalPage = data.data.total_page;
      });
    });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.currentPage = 1;
    this.fetchHospitals();
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    this.orderValue = ev["order"] === "ascending" ? "1" : "0";
    this.currentPage = 1;
    this.fetchHospitals();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.currentPage = val;
    this.fetchHospitals();
  }
  /**
   * @description 处理添加成员完成
   */
  private handleAddedFinish(ev) {
    this.ifShowAddHospitalDialog = false;
    this.fetchHospitals();
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    this.project.project_id = this.$route.params.project_id;
    this.fetchProject().then(() => {
      this.fetchHospitals();
    });
  }
}
